<div class="background-hack"></div>

@if (exercise) {
  <main class="container">
    <section class="col-8 mx-auto text-center">
      <header class="mb-0">
        <h1>{{ exercise.title }}</h1>
      </header>
      <div class="embed-responsive embed-responsive-16by9 my-4">
        <!--TODO: The source of the iframe should be changed to 'exercise.videoLink' but the values currently in do not load as they are not videos-->
        <iframe class="embed-responsive-item" [src]="videoUrl" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>
      </div>
      <p>{{ exercise.introCopy }}</p>
      <!--TODO: What should this button link to?-->
      <a class="btn btn-primary btn-lg" (click)="handleGetStarted(exercise.id)">Get Started</a>
      <br><br>
    </section>
  </main>
}
